<template>
    <div style="background-color: whitesmoke;">
        <b-modal id="modal-1"  hide-footer hide-header centered no-close-on-backdrop>
            <b-progress value="100" max="100" animated variant="secondary"></b-progress>
        </b-modal>
        
        <CCardBody class="tips_statistic_table_modify">
            <h5>{{ $t('Stats') }}</h5>
            <CDataTable
                :items="items1"
                :fields="fields"
                hover
                border
                striped
                outlined
               
            >
                <template v-slot:thead-top="props">                
                    <tr class="first_tr">
                        <th colspan="3">{{ $t('League') }}</th>
                        <th colspan="6">{{ $t('Match Result %') }}</th>
                        <th colspan="3">{{ $t('Average Goals') }}</th>
                        <th colspan="3">{{ $t('Fist Half Overs %') }}</th>
                        <th colspan="3">{{ $t('Second Half Overs %') }}</th>
                        <th colspan="5">{{ $t('Full Match Overs %') }}</th>
                        <th colspan="1"></th>
                        <th colspan="6">{{ $t('Goal Bands [% of matches with at least one goal in time period') }}</th>
                        <th colspan="2">{{ $t('1st goal avg min') }}</th>
                        <th colspan="4">{{ $t('First To Score') }}</th>
                    </tr>                  
                </template>
                <template #Matches="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <a :href="'/#/viewevents?idlist=' + item.Matches_ids" target="_blank">{{item.Matches}}</a>
                    </td>
                </template>
                <template #home="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.home}}</span>
                        <span :id="'home_' + item.uuid" :class="{'span-roi-green' : item.roi['Home - FT'].roi > 0, 'span-roi-red' : item.roi['Home - FT'].roi < 0}">{{item.roi["Home - FT"].roi}}</span>

                        <b-tooltip :target="'home_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Home - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Home - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Home - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Home - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Home - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #away="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.away}}</span>
                        <span :id="'away_' + item.uuid" :class="{'span-roi-green' : item.roi['Away - FT'].roi > 0, 'span-roi-red' : item.roi['Away - FT'].roi < 0}">{{item.roi["Away - FT"].roi}}</span>

                        <b-tooltip :target="'away_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Away - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Away - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Away - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Away - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Away - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #draw="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.draw}}</span>
                        <span :id="'draw_' + item.uuid" :class="{'span-roi-green' : item.roi['Draw - FT'].roi > 0, 'span-roi-red' : item.roi['Draw - FT'].roi < 0}">{{item.roi["Draw - FT"].roi}}</span>
                        <b-tooltip :target="'draw_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Draw - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Draw - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Draw - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Draw - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Draw - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #home_pt_percent="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.home_pt_percent}}</span>
                        <span :id="'home_pt_percent_' + item.uuid" :class="{'span-roi-green' : item.roi['Home - HT'].roi > 0, 'span-roi-red' : item.roi['Home - HT'].roi < 0}">{{item.roi["Home - HT"].roi}}</span>
                        <b-tooltip :target="'home_pt_percent_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Home - HT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Home - HT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Home - HT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Home - HT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Home - HT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #away_pt_percent="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.away_pt_percent}}</span>
                        <span :id="'away_pt_percent_' + item.uuid" :class="{'span-roi-green' : item.roi['Away - HT'].roi > 0, 'span-roi-red' : item.roi['Away - HT'].roi < 0}">{{item.roi["Away - HT"].roi}}</span>
                        <b-tooltip :target="'away_pt_percent_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Away - HT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Away - HT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Away - HT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Away - HT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Away - HT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #draw_pt_percent="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.draw_pt_percent}}</span>
                        <span :id="'draw_pt_percent_' + item.uuid" :class="{'span-roi-green' : item.roi['Draw - HT'].roi > 0, 'span-roi-red' : item.roi['Draw - HT'].roi < 0}">{{item.roi["Draw - HT"].roi}}</span>
                        <b-tooltip :target="'draw_pt_percent_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Draw - HT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Draw - HT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Draw - HT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Draw - HT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Draw - HT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #0.5FH="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["0.5FH"]}}</span>
                        <span :id="'over05_ht_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 0.5 - HT'].roi > 0, 'span-roi-red' : item.roi['Over - 0.5 - HT'].roi < 0}">{{item.roi["Over - 0.5 - HT"].roi}}</span>
                        <b-tooltip :target="'over05_ht_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 0.5 - HT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 0.5 - HT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 0.5 - HT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 0.5 - HT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 0.5 - HT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #1.5FH="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["1.5FH"]}}</span>
                        <span :id="'over15_ht_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 1.5 - HT'].roi > 0, 'span-roi-red' : item.roi['Over - 1.5 - HT'].roi < 0}">{{item.roi["Over - 1.5 - HT"].roi}}</span>
                        <b-tooltip :target="'over15_ht_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 1.5 - HT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 1.5 - HT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 1.5 - HT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 1.5 - HT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 1.5 - HT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #2.5FH="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["2.5FH"]}}</span>
                        <span :id="'over25_ht_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 2.5 - HT'].roi > 0, 'span-roi-red' : item.roi['Over - 2.5 - HT'].roi < 0}">{{item.roi["Over - 2.5 - HT"].roi}}</span>
                        <b-tooltip :target="'over25_ht_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 2.5 - HT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 2.5 - HT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 2.5 - HT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 2.5 - HT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 2.5 - HT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #0.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["0.5"]}}</span>
                        <span :id="'over05_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 0.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 0.5 - FT'].roi < 0}">{{item.roi["Over - 0.5 - FT"].roi}}</span>
                        <b-tooltip :target="'over05_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 0.5 - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 0.5 - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 0.5 - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 0.5 - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 0.5 - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #1.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["1.5"]}}</span>
                        <span :id="'over15_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 1.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 1.5 - FT'].roi < 0}">{{item.roi["Over - 1.5 - FT"].roi}}</span>
                        <b-tooltip :target="'over15_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 1.5 - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 1.5 - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 1.5 - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 1.5 - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 1.5 - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #2.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["2.5"]}}</span>
                        <span :id="'over25_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 2.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 2.5 - FT'].roi < 0}">{{item.roi["Over - 2.5 - FT"].roi}}</span>
                        <b-tooltip :target="'over25_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 2.5 - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 2.5 - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 2.5 - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 2.5 - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 2.5 - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #3.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["3.5"]}}</span>
                        <span :id="'over35_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 3.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 3.5 - FT'].roi < 0}">{{item.roi["Over - 3.5 - FT"].roi}}</span>
                        <b-tooltip :target="'over35_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 3.5 - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 3.5 - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 3.5 - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 3.5 - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 3.5 - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #4.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["4.5"]}}</span>
                        <span :id="'over45_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 4.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 4.5 - FT'].roi < 0}">{{item.roi["Over - 4.5 - FT"].roi}}</span>
                        <b-tooltip :target="'over45_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 4.5 - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 4.5 - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 4.5 - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 4.5 - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 4.5 - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #bts="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["bts"]}}</span>
                        <span :id="'bts_' + item.uuid" :class="{'span-roi-green' : item.roi['BTS - FT'].roi > 0, 'span-roi-red' : item.roi['BTS - FT'].roi < 0}">{{item.roi["BTS - FT"].roi}}</span>
                        <b-tooltip :target="'bts_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['BTS - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['BTS - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['BTS - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['BTS - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['BTS - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
            </CDataTable>

            <h5>{{ $t('Stats by league') }}</h5>
            <CDataTable
                :items="items2"
                :fields="fields"
                sorter
                tableFilter
                hover
                border
                striped
                outlined
               
            >
                <template v-slot:thead-top="props">                
                    <tr class="first_tr">
                        <th colspan="3">{{ $t('League') }}</th>
                        <th colspan="6">{{ $t('Match Result %') }}</th>
                        <th colspan="3">{{ $t('Average Goals') }}</th>
                        <th colspan="3">{{ $t('Fist Half Overs %') }}</th>
                        <th colspan="3">{{ $t('Second Half Overs %') }}</th>
                        <th colspan="5">{{ $t('Full Match Overs %') }}</th>
                        <th colspan="1"></th>
                        <th colspan="6">{{ $t('Goal Bands [% of matches with at least one goal in time period') }}</th>
                        <th colspan="2">{{ $t('1st goal avg min') }}</th>
                        <th colspan="4">{{ $t('First To Score') }}</th>
                    </tr>                
                </template>
                <template #Matches="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <a :href="'/#/viewevents?idlist=' + item.Matches_ids" target="_blank">{{item.Matches}}</a>
                    </td>
                   
                </template>
                <!-- <template #home="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.home}}</span>
                        <span :class="{'span-roi-green' : item.roi['Home - FT'].roi > 0, 'span-roi-red' : item.roi['Home - FT'].roi < 0}">{{item.roi["Home - FT"].roi}}</span>
                    </td>
                </template>
                <template #away="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.away}}</span>
                        <span :class="{'span-roi-green' : item.roi['Away - FT'].roi > 0, 'span-roi-red' : item.roi['Away - FT'].roi < 0}">{{item.roi["Away - FT"].roi}}</span>
                    </td>
                </template>
                <template #draw="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.draw}}</span>
                        <span :class="{'span-roi-green' : item.roi['Draw - FT'].roi > 0, 'span-roi-red' : item.roi['Draw - FT'].roi < 0}">{{item.roi["Draw - FT"].roi}}</span>
                    </td>
                </template>
                <template #home_pt_percent="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.home_pt_percent}}</span>
                        <span :class="{'span-roi-green' : item.roi['Home - HT'].roi > 0, 'span-roi-red' : item.roi['Home - HT'].roi < 0}">{{item.roi["Home - HT"].roi}}</span>
                    </td>
                </template>
                <template #away_pt_percent="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.away_pt_percent}}</span>
                        <span :class="{'span-roi-green' : item.roi['Away - HT'].roi > 0, 'span-roi-red' : item.roi['Away - HT'].roi < 0}">{{item.roi["Away - HT"].roi}}</span>
                    </td>
                </template>
                <template #draw_pt_percent="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.draw_pt_percent}}</span>
                        <span :class="{'span-roi-green' : item.roi['Draw - HT'].roi > 0, 'span-roi-red' : item.roi['Draw - HT'].roi < 0}">{{item.roi["Draw - HT"].roi}}</span>
                    </td>
                </template>
                <template #0.5FH="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["0.5FH"]}}</span>
                        <span :class="{'span-roi-green' : item.roi['Over - 0.5 - HT'].roi > 0, 'span-roi-red' : item.roi['Over - 0.5 - HT'].roi < 0}">{{item.roi["Over - 0.5 - HT"].roi}}</span>
                    </td>
                </template>
                <template #1.5FH="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["1.5FH"]}}</span>
                        <span :class="{'span-roi-green' : item.roi['Over - 1.5 - HT'].roi > 0, 'span-roi-red' : item.roi['Over - 1.5 - HT'].roi < 0}">{{item.roi["Over - 1.5 - HT"].roi}}</span>
                    </td>
                </template>
                <template #2.5FH="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["2.5FH"]}}</span>
                        <span :class="{'span-roi-green' : item.roi['Over - 2.5 - HT'].roi > 0, 'span-roi-red' : item.roi['Over - 2.5 - HT'].roi < 0}">{{item.roi["Over - 2.5 - HT"].roi}}</span>
                    </td>
                </template>
                <template #0.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["0.5"]}}</span>
                        <span :class="{'span-roi-green' : item.roi['Over - 0.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 0.5 - FT'].roi < 0}">{{item.roi["Over - 0.5 - FT"].roi}}</span>
                    </td>
                </template>
                <template #1.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["1.5"]}}</span>
                        <span :class="{'span-roi-green' : item.roi['Over - 1.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 1.5 - FT'].roi < 0}">{{item.roi["Over - 1.5 - FT"].roi}}</span>
                    </td>
                </template>
                <template #2.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["2.5"]}}</span>
                        <span :class="{'span-roi-green' : item.roi['Over - 2.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 2.5 - FT'].roi < 0}">{{item.roi["Over - 2.5 - FT"].roi}}</span>
                    </td>
                </template>
                <template #3.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["3.5"]}}</span>
                        <span :class="{'span-roi-green' : item.roi['Over - 3.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 3.5 - FT'].roi < 0}">{{item.roi["Over - 3.5 - FT"].roi}}</span>
                    </td>
                </template>
                <template #4.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["4.5"]}}</span>
                        <span :class="{'span-roi-green' : item.roi['Over - 4.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 4.5 - FT'].roi < 0}">{{item.roi["Over - 4.5 - FT"].roi}}</span>
                    </td>
                </template>
                <template #bts="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["bts"]}}</span>
                        <span :class="{'span-roi-green' : item.roi['BTS - FT'].roi > 0, 'span-roi-red' : item.roi['BTS - FT'].roi < 0}">{{item.roi["BTS - FT"].roi}}</span>
                    </td>
                </template> -->
                <template #home="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.home}}</span>
                        <span :id="'home_' + item.uuid" :class="{'span-roi-green' : item.roi['Home - FT'].roi > 0, 'span-roi-red' : item.roi['Home - FT'].roi < 0}">{{item.roi["Home - FT"].roi}}</span>

                        <b-tooltip :target="'home_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Home - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Home - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Home - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Home - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Home - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #away="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.away}}</span>
                        <span :id="'away_' + item.uuid" :class="{'span-roi-green' : item.roi['Away - FT'].roi > 0, 'span-roi-red' : item.roi['Away - FT'].roi < 0}">{{item.roi["Away - FT"].roi}}</span>

                        <b-tooltip :target="'away_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Away - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Away - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Away - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Away - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Away - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #draw="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.draw}}</span>
                        <span :id="'draw_' + item.uuid" :class="{'span-roi-green' : item.roi['Draw - FT'].roi > 0, 'span-roi-red' : item.roi['Draw - FT'].roi < 0}">{{item.roi["Draw - FT"].roi}}</span>
                        <b-tooltip :target="'draw_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Draw - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Draw - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Draw - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Draw - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Draw - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #home_pt_percent="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.home_pt_percent}}</span>
                        <span :id="'home_pt_percent_' + item.uuid" :class="{'span-roi-green' : item.roi['Home - HT'].roi > 0, 'span-roi-red' : item.roi['Home - HT'].roi < 0}">{{item.roi["Home - HT"].roi}}</span>
                        <b-tooltip :target="'home_pt_percent_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Home - HT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Home - HT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Home - HT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Home - HT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Home - HT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #away_pt_percent="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.away_pt_percent}}</span>
                        <span :id="'away_pt_percent_' + item.uuid" :class="{'span-roi-green' : item.roi['Away - HT'].roi > 0, 'span-roi-red' : item.roi['Away - HT'].roi < 0}">{{item.roi["Away - HT"].roi}}</span>
                        <b-tooltip :target="'away_pt_percent_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Away - HT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Away - HT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Away - HT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Away - HT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Away - HT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #draw_pt_percent="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item.draw_pt_percent}}</span>
                        <span :id="'draw_pt_percent_' + item.uuid" :class="{'span-roi-green' : item.roi['Draw - HT'].roi > 0, 'span-roi-red' : item.roi['Draw - HT'].roi < 0}">{{item.roi["Draw - HT"].roi}}</span>
                        <b-tooltip :target="'draw_pt_percent_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Draw - HT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Draw - HT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Draw - HT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Draw - HT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Draw - HT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #0.5FH="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["0.5FH"]}}</span>
                        <span :id="'over05_ht_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 0.5 - HT'].roi > 0, 'span-roi-red' : item.roi['Over - 0.5 - HT'].roi < 0}">{{item.roi["Over - 0.5 - HT"].roi}}</span>
                        <b-tooltip :target="'over05_ht_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 0.5 - HT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 0.5 - HT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 0.5 - HT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 0.5 - HT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 0.5 - HT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #1.5FH="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["1.5FH"]}}</span>
                        <span :id="'over15_ht_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 1.5 - HT'].roi > 0, 'span-roi-red' : item.roi['Over - 1.5 - HT'].roi < 0}">{{item.roi["Over - 1.5 - HT"].roi}}</span>
                        <b-tooltip :target="'over15_ht_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 1.5 - HT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 1.5 - HT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 1.5 - HT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 1.5 - HT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 1.5 - HT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #2.5FH="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["2.5FH"]}}</span>
                        <span :id="'over25_ht_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 2.5 - HT'].roi > 0, 'span-roi-red' : item.roi['Over - 2.5 - HT'].roi < 0}">{{item.roi["Over - 2.5 - HT"].roi}}</span>
                        <b-tooltip :target="'over25_ht_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 2.5 - HT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 2.5 - HT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 2.5 - HT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 2.5 - HT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 2.5 - HT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #0.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["0.5"]}}</span>
                        <span :id="'over05_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 0.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 0.5 - FT'].roi < 0}">{{item.roi["Over - 0.5 - FT"].roi}}</span>
                        <b-tooltip :target="'over05_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 0.5 - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 0.5 - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 0.5 - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 0.5 - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 0.5 - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #1.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["1.5"]}}</span>
                        <span :id="'over15_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 1.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 1.5 - FT'].roi < 0}">{{item.roi["Over - 1.5 - FT"].roi}}</span>
                        <b-tooltip :target="'over15_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 1.5 - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 1.5 - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 1.5 - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 1.5 - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 1.5 - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #2.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["2.5"]}}</span>
                        <span :id="'over25_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 2.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 2.5 - FT'].roi < 0}">{{item.roi["Over - 2.5 - FT"].roi}}</span>
                        <b-tooltip :target="'over25_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 2.5 - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 2.5 - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 2.5 - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 2.5 - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 2.5 - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #3.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["3.5"]}}</span>
                        <span :id="'over35_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 3.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 3.5 - FT'].roi < 0}">{{item.roi["Over - 3.5 - FT"].roi}}</span>
                        <b-tooltip :target="'over35_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 3.5 - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 3.5 - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 3.5 - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 3.5 - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 3.5 - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #4.5="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["4.5"]}}</span>
                        <span :id="'over45_' + item.uuid" :class="{'span-roi-green' : item.roi['Over - 4.5 - FT'].roi > 0, 'span-roi-red' : item.roi['Over - 4.5 - FT'].roi < 0}">{{item.roi["Over - 4.5 - FT"].roi}}</span>
                        <b-tooltip :target="'over45_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['Over - 4.5 - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['Over - 4.5 - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['Over - 4.5 - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['Over - 4.5 - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['Over - 4.5 - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
                <template #bts="{item, index}" style="background-color:#dff0d8 !important;">
                    <td>
                        <span style="display: block;">{{item["bts"]}}</span>
                        <span :id="'bts_' + item.uuid" :class="{'span-roi-green' : item.roi['BTS - FT'].roi > 0, 'span-roi-red' : item.roi['BTS - FT'].roi < 0}">{{item.roi["BTS - FT"].roi}}</span>
                        <b-tooltip :target="'bts_' + item.uuid" triggers="hover">
                            <p>ROI: {{ item.roi['BTS - FT'].roi + "%" }}</p>
                            <p>avg odds: {{ item.roi['BTS - FT'].avg_odd }}</p>
                            <p>total profits: {{ item.roi['BTS - FT'].profit.toFixed(2) }}</p>
                            <p>win/rate: {{ item.roi['BTS - FT'].win_per + "%" }}</p>
                            <p>Odd available: {{ item.roi['BTS - FT'].count }}</p>
                        </b-tooltip>
                    </td>
                </template>
            </CDataTable>
        </CCardBody>
    </div>
</template>

<script>
import { Plotly } from 'vue-plotly'
import swal from "sweetalert2";
import { mapActions, mapGetters } from 'vuex';
// const fields = [
//     this.$t('Country'),
//     'League',    
//     'Matches',
//     'home',
//     'draw',
//     'away',
//     { key: '1st Half', label: '1st Half', _style: "width: '50px'" },
//     '2nd Half',
//     'total',
//     { key: '0.5 FH', label: '0.5 FH'},
//     { key: '1.5 FH', label: '1.5 FH'},
//     { key: '2.5 FH', label: '2.5 FH'},
//     { key: '0.5', label: '0.5'},
//     { key: '1.5', label: '1.5'},
//     { key: '2.5', label: '2.5'},
//     { key: '3.5', label: '3.5'},
//     { key: '4.5', label: '4.5'},    
    
//     'bts',
//     '0~15',
//     '16~30',
//     '31~45',
//     '46~60',
//     '61~75',
//     '76~90',
//     'Home',
//     'H Win',
//     'Away',
//     'A Win'
// ]


export default {
    name: 'StatisticTable',
    components: {
        Plotly,
       
    },
    props: {
        items1: {
            type: Array,
            default: () => []
        },
        items2: {
            type: Array,
            default: () => []
        },
    },
    data () {
        return {
            
            startDate: 1325376000000,
            endDate: 1330560000000,
            
            fields: [
                { key: 'Country', label: this.$t('Country')},
                { key: 'League', label: this.$t('League')},
                { key: 'Matches', label: this.$t('Matches')},
                { key: 'home', label: this.$t('home')},
                { key: 'draw', label: this.$t('draw')},
                { key: 'away', label: this.$t('away')},
                { key: 'home_pt_percent', label: this.$t('home fh')},
                { key: 'draw_pt_percent', label: this.$t('draw fh')},
                { key: 'away_pt_percent', label: this.$t('away fh')},
                { key: '1st Half', label: this.$t('1st Half'), _style: "width: '50px'" },
                { key: '2nd Half', label: this.$t('2nd Half')},
                { key: 'total', label: this.$t('total')},                
                { key: '0.5FH', label: this.$t('0.5 FH')},
                { key: '1.5FH', label: this.$t('1.5 FH')},
                { key: '2.5FH', label: this.$t('2.5 FH')},
                { key: 'sh_05_percent', label: this.$t('0.5 SH')},
                { key: 'sh_15_percent', label: this.$t('1.5 SH')},
                { key: 'sh_25_percent', label: this.$t('2.5 SH')},
                { key: '0.5', label: '0.5'},
                { key: '1.5', label: '1.5'},
                { key: '2.5', label: '2.5'},
                { key: '3.5', label: '3.5'},
                { key: '4.5', label: '4.5'},                
                'bts',
                '0~15',
                '16~30',
                '31~45',
                '46~60',
                '61~75',
                '76~90',
                { key: 'ht_firstGoal_min_avg', label: this.$t('FH')},
                { key: 'sh_firstGoal_min_avg', label: this.$t('SH')},
                { key: 'Home', label: this.$t('Home')},
                { key: 'H Win', label: this.$t('H Win')},
                { key: 'Away', label: this.$t('Away')},
                { key: 'A Win', label: this.$t('A Win')}                
            ],
            loading: true
        }
    },
    created() {
        console.log('==============  created function')
    },
    mounted: function (){
        this.$nextTick(function () {
            console.log('==============  mounted function')
            

        })
    },
    methods: {
        ...mapActions([
                'getStatsByUserId'
            ]),
        
        showModal() {
            // this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')

            console.log('show modal')
            this.$bvModal.show('modal-1')
            console.log('show modal close')
        },
        hideModal() {
            this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
        },
    }
}
</script>
<style scoped>

</style>
<style>


.tips_statistic_table_modify .table-responsive{
    margin-top: 20px !important;
    max-height: 60vh !important;
}

thead {
    padding: 3px;
    position: sticky;
    top: 0;
    z-index: 1;
    /* width: 25vw; */
    background: white;
}
.first_tr{
    background-color: #bae1aa ;
}
.first_tr + tr{
    background-color: #dff0d8;
}
.span-roi-green {
   /* display: block !important;*/
    font-size: 12px !important;
    background-color: green !important;
    border-radius: 5px;
    padding: 5px;
    color: white;
}
.span-roi-red {
    /*display: block !important;*/
    font-size: 12px !important;
    background-color: red !important;
    border-radius: 5px;
    padding: 5px;
    color: white;
}
</style>